import { useFormatDate } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
	GuestTravelInquiry,
	GuestTravelInquiryFlight,
	GuestTravelInquiryTrain,
} from "../../../../../../shared/types/travelInquiry";
import { Strong, TwoColumnCard } from "./Card";
import { LabeledValue } from "./LabeledValue";

interface Props<T extends GuestTravelInquiry> {
	travelInquiry: T;
}

export const TravelInquirySummaryCard: FC<Props<GuestTravelInquiry>> = ({ travelInquiry }) => {
	switch (travelInquiry.type) {
		case "flight":
			return <TravelInquiryFlightCard travelInquiry={travelInquiry} />;
		case "train":
			return <TravelInquiryTrainCard travelInquiry={travelInquiry} />;
	}
};

export const TravelInquiryFlightCard: FC<Props<GuestTravelInquiryFlight>> = ({ travelInquiry }) => {
	const { t } = useTranslation();
	const formatDate = useFormatDate();

	return (
		<TwoColumnCard>
			<Strong>{t("Inquiry")}</Strong>
			<span />
			<LabeledValue label={t("Departure location")}>
				{travelInquiry.departureLocation?.iataCode} ({travelInquiry.departureLocation?.name})
			</LabeledValue>
			<LabeledValue label={t("Arrival location")}>
				{travelInquiry.arrivalLocation?.iataCode} ({travelInquiry.arrivalLocation?.name})
			</LabeledValue>
			<LabeledValue label={t("Earliest departure time")}>
				{formatDate(travelInquiry.earliestDepartureDate)} {travelInquiry.earliestDepartureTime}
			</LabeledValue>
			<LabeledValue label={t("Latest arrival time")}>
				{formatDate(travelInquiry.latestArrivalDate)} {travelInquiry.latestArrivalTime}
			</LabeledValue>
			<LabeledValue label={t("Travel type")}>{t(travelInquiry.type)}</LabeledValue>
			<LabeledValue label={t("Remarks")}>{t(travelInquiry.remarks || "-")}</LabeledValue>
		</TwoColumnCard>
	);
};

export const TravelInquiryTrainCard: FC<Props<GuestTravelInquiryTrain>> = ({ travelInquiry }) => {
	const { t } = useTranslation();
	const formatDate = useFormatDate();

	return (
		<TwoColumnCard>
			<Strong>{t("Inquiry")}</Strong>
			<span />
			<LabeledValue label={t("Departure location")}>{travelInquiry.departureLocation}</LabeledValue>
			<LabeledValue label={t("Arrival location")}>{travelInquiry.arrivalLocation}</LabeledValue>
			<LabeledValue label={t("Earliest departure time")}>
				{formatDate(travelInquiry.earliestDepartureDate)} {travelInquiry.earliestDepartureTime}
			</LabeledValue>
			<LabeledValue label={t("Latest arrival time")}>
				{formatDate(travelInquiry.latestArrivalDate)} {travelInquiry.latestArrivalTime}
			</LabeledValue>
			<LabeledValue label={t("Travel type")}>{t(travelInquiry.type)}</LabeledValue>
			<LabeledValue label={t("Remarks")}>{t(travelInquiry.remarks || "-")}</LabeledValue>
		</TwoColumnCard>
	);
};
